// extracted by mini-css-extract-plugin
export default {"subTitle":"index_subTitle__ntGue","cancel":"index_cancel__OaKui"};